import { useEffect, useState } from "react";
import { IMinerViewBlockProps } from "./MinerViewBlock.props";

type MinerDimensionsType = number | undefined;

export const useMinerViewBlockControl = (props: IMinerViewBlockProps) => {
  const meta = props.meta;

  const [width, setWidth] = useState<MinerDimensionsType>(meta?.width);
  const [height, setHeight] = useState<MinerDimensionsType>(meta?.height);
  const [depth, setDepth] = useState<MinerDimensionsType>(meta?.depth);

  useEffect(() => {
    setWidth(meta?.width);
    setHeight(meta?.height);
    setDepth(meta?.depth);
  }, [meta]);

  const setMinerParam = (p: number, type: "w" | "h" | "d") => {
    switch (type) {
      case "w":
        setWidth(p);
        break;
      case "h":
        setHeight(p);
        break;
      case "d":
        setDepth(p);
        break;
    }
  };

  const lengthConverter = (num: number) => {
    const meters = Number((num / 1000000000).toFixed(8));

    return {
      value: meters,
      unit: "м",
    };
  };

  useEffect(() => {
    if (!props.reset) return;

    setWidth(meta?.width);
    setHeight(meta?.height);
    setDepth(meta?.depth);
  }, [props.reset]);

  return {
    width,
    height,
    depth,

    setMinerParam,
    lengthConverter,
  };
};
